import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../sync/db.js";
import type { CookSessionApiItem } from "@recipevault/shared";

/** Live list of open (active/paused/waiting) cook sessions from Dexie. */
export function useOpenCookSessions(): CookSessionApiItem[] {
  return useLiveQuery(() => db.cookSessions.toArray(), [], [] as CookSessionApiItem[]);
}
